import { routerMiddleware as reduxRouterMiddleware } from 'react-router-redux';
import { History } from 'history';
import { createBrowserHistory } from 'history';

import {
  configureStore,
  type Reducer,
  type Middleware,
  type Action,
  type ThunkAction,
  type ThunkDispatch,
} from '@reduxjs/toolkit';
import { rootReducer } from '../../store/reducers';

export const initStore = (history: History, reducer: Reducer, urlMiddleware?: Middleware) => {
  const routerMiddleware = reduxRouterMiddleware(history);

  const store = configureStore({
    reducer: rootReducer,
    devTools: import.meta.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) => {
      let middleware: any = getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).concat(routerMiddleware);
      
      if (urlMiddleware) {
        middleware = middleware.concat(urlMiddleware);
      }
      return middleware;
    },
  });
  return store;
};

export const history = createBrowserHistory();

export type RootState = ReturnType<typeof rootReducer>;
export type FunctionalRootState = RootState;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
export type AppDispatch = ThunkDispatch<RootState, unknown, Action<string>>;
